<template>
<div class="container">
    <div class="item">
      <div> <img :src="logo[0]" class="con">
        <span>
           <a @click="towins(new_id)" >公告通知</a>
        </span>
      </div>

    </div>
    <div class="item">
      <div>
        <img :src="logo[1]" alt="">
        <span>
           <a @click="towin(`http://www.hrnygs.com/admin`)">在线投稿</a>
        </span>
      </div>

    </div>
    <div class="item">
      <div>
        <img :src="logo[2]" alt="">
        <span>
           <a @click="towin(`http://192.168.1.80/cmoa/`)">办公系统</a>
        </span>
      </div>

    </div>
    <div class="item">
      <div>
        <img :src="logo[3]" alt="" style="width:50px;height:50px;padding-top:5px">
        <span style="positon: relative; top: -13px">
           <a @click="towin(`http://ztb.cmjt.com.cn`)">招标平台</a>
        </span>
      </div>
    </div>

</div>
</template>

<script>
import logo1 from '@/assets/img/logo1.png'
import logo2 from '@/assets/img/logo4.png'
import logo3 from '@/assets/img/logo3.png'
import logo5 from '@/assets/img/logo5.png'
import axios from "axios";
import {orgId, requestUrl} from "../common/cons";
export default {
  name: "End",
  data(){
    return{
      "logo":[logo1,logo2,logo3,logo5],
      new_id:0,
    }
  },
  mounted() {
    this.getNoticeList()
  },
  methods:{
    async getNoticeList () {
      const result = await axios.get(`${requestUrl}/notice/${orgId}`)
      if(result.data.length>0){
        this.noticeList = result.data[0].title
        this.new_id=result.data[0].article_id;
      }

    },
    towin(id) {
      window.open(id)
    },
    towins(id) {
      const routePath = this.$router.resolve({
        path: `/content/${id}`
      })
      window.open(routePath.href)
    },
  }
}
</script>

<style scoped>
.container{

  clear: both;
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  justify-content: space-around;
  width: 100%;

}
/*.container-img{*/

/*}*/
.container img{
  width: 60px;
  margin-right: 25px;
}
/*.item:nth-child(2){*/
/*  margin: 0 30px;*/
/*}*/
.item{
  width: 32%;
  margin: 25px 0;
  background-color: white;
  /*box-shadow: 1px 1px 4px #ccc;*/
  padding: 10px 0;
}
.item div{
  width: 200px;
  height: 60px;
  margin: 0 auto;
}
.item span{
 position: relative;
  top: -18px;
}
.item a{
  font-size: 23px;
  text-decoration: none;
  color: cornflowerblue;
  cursor: pointer;
}
.item a:hover{
  color: red;
}
.con{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/End.vue